module.exports = __webpack_public_path__ + "img/bi.e05683e3.svg";